import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { marketplaceApi } from "../api/client";
import MarketplaceHeader from "../components/MarketplaceHeader";
import TransporterServiceCard from "../components/TransporterServiceCard";
import FloatingTools from "../components/FloatingTools";
import Footer from "../components/Footer";

export default function TransporterServices() {
  const [services, setServices] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function load(params = {}) {
    setLoading(true);
    setError("");
    try {
      const res = await marketplaceApi.transporterServices(params);
      setServices(Array.isArray(res.data?.services) ? res.data.services : []);
    } catch {
      setError("Transporter services could not be loaded right now.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  function search(event) {
    event.preventDefault();
    load({ q: query });
  }

  return (
    <div className="page-shell transporter-public-page" id="top">
      <MarketplaceHeader apiOnline />
      <main className="container transporter-public-main">
        <section className="marketplace-title-banner marketplace-title-banner--transport">
          <img src="/images/tazy-transport-truck.jpg" alt="" />
          <div className="marketplace-title-banner__content">
            <span>TAZY LOGISTICS NETWORK</span>
            <h1>Find registered transporters for marketplace deliveries.</h1>
            <p>Browse delivery services by area, vehicle type, route and pricing notes before assigning fulfilment to an order.</p>
            <form onSubmit={search} className="marketplace-title-search">
              <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search by route, city, transporter or service" />
              <button type="submit">Search services</button>
            </form>
          </div>
        </section>

        <section className="transport-steps-strip">
          <div><strong>1</strong><span>Seller confirms order</span></div>
          <div><strong>2</strong><span>Choose suitable service</span></div>
          <div><strong>3</strong><span>Transporter accepts job</span></div>
          <div><strong>4</strong><span>Pickup, transit and delivery tracking</span></div>
        </section>

        <section className="transporter-public-grid-section">
          <div className="section-heading">
            <div><h2>Transporter services</h2><p>{loading ? "Loading services..." : `${services.length} service(s) available.`}</p></div>
            <div className="section-heading-actions"><button type="button" onClick={() => load()}>Refresh</button><Link to="/register?type=COURIER">List delivery service</Link></div>
          </div>
          {error ? <div className="marketplace-empty-feed">{error}</div> : null}
          <div className="transport-services-market-grid">
            {services.map((service) => <TransporterServiceCard key={service.id} service={service} />)}
          </div>
          {!loading && !services.length && !error ? <div className="marketplace-empty-feed">No approved transporter services are available yet.</div> : null}
        </section>
      </main>
      <Footer />
      <FloatingTools />
    </div>
  );
}
